<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-layout xs4 mb-2>
          <v-flex mt-4>
            <h1>Manutenção de Notificações</h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <hr class="solid" />
    <template>
      <v-tabs v-model="tab">
        <v-tab>Notificações Avulsas</v-tab>
        <v-tab>Notificações Automáticas</v-tab>
      </v-tabs>
    </template>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, -1],
            }"
            :items-per-page="10"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  {{
                    new Date(item.dataProgramadaEnvio).toLocaleDateString(
                      "pt-BR"
                    )
                  }}&nbsp;{{
                    new Date(item.dataProgramadaEnvio).toLocaleTimeString(
                      "pt-BR"
                    )
                  }}
                </td>

                <td>{{ item.corpoNotificacao }}</td>
                <td align="center">
                  <v-chip
                    class="ma-2"
                    color="orange"
                    text-color="white"
                    v-if="item.statusEnvio === 'AGENDADO'"
                  >
                    {{ item.statusEnvio }}
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    color="green"
                    text-color="white"
                    v-if="item.statusEnvio === 'ENVIADO'"
                  >
                    {{ item.statusEnvio }}
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    color="red"
                    text-color="white"
                    v-if="item.statusEnvio === 'FALHA'"
                  >
                    {{ item.statusEnvio }}
                  </v-chip>
                </td>
                <td>
                  <v-layout>
                    <v-menu
                      origin="center center"
                      top
                      :offset-x="false"
                      :offset-y="true"
                      class="transparent"
                      transition="slide-y-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="btn-list"
                          elevation="0"
                          color="transparent"
                          v-bind="attrs"
                          v-on="on"
                        >
                          ...
                        </v-btn>
                      </template>
                      <v-list class="tooltip menu-balloon">
                        <div>
                          <v-list-item
                            @click="editarNotificacao(item)"
                            v-if="item.statusEnvio === 'AGENDADO'"
                          >
                            <v-flex class="d-flex justify-center">
                              Editar
                            </v-flex>
                          </v-list-item>
                          <v-list-item
                            @click="excluirNotificacao(item)"
                            v-if="item.statusEnvio === 'AGENDADO'"
                          >
                            <v-flex class="d-flex justify-center">
                              Excluir
                            </v-flex>
                          </v-list-item>
                          <v-list-item @click="listarCotas(item)">
                            <v-flex class="d-flex justify-center">
                              Listar Cotas
                            </v-flex>
                          </v-list-item>
                        </div>
                      </v-list>
                      <div class="arrow-down-lil"></div>
                    </v-menu>
                  </v-layout>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-card-text v-if="notificacoesAutomaticas.length === 0">
            <v-alert dense type="success">
              Ops! Não há nenhuma Notificação Automatica Cadastrada até o
              momento
            </v-alert>
          </v-card-text>
          <v-data-table
            v-else
            :headers="headersNotificacoesAutomaticas"
            :items="notificacoesAutomaticas"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, -1],
            }"
            :items-per-page="10"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ tipos.find((x) => x.value == item.tipo).text }}</td>
                <td>
                  {{ meiosEnvio.find((x) => x.value == item.meioEnvio).text }}
                </td>
                <td>{{ item.assunto }}</td>
                <td>{{ item.corpoNotificacao }}</td>
                <td>
                  <v-layout>
                    <v-menu
                      origin="center center"
                      top
                      :offset-x="false"
                      :offset-y="true"
                      class="transparent"
                      transition="slide-y-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="btn-list"
                          elevation="0"
                          color="transparent"
                          v-bind="attrs"
                          v-on="on"
                        >
                          ...
                        </v-btn>
                      </template>
                      <v-list class="tooltip menu-balloon">
                        <div>
                          <v-list-item
                            @click="excluirNotificacaoAutomatica(item)"
                          >
                            <v-flex class="d-flex justify-center">
                              Excluir
                            </v-flex>
                          </v-list-item>
                        </div>
                      </v-list>
                      <div class="arrow-down-lil"></div>
                    </v-menu>
                  </v-layout>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { alert, error } from "@/plugins/helpers";

export default {
  name: "ListaNotificacoes",
  data: () => ({
    items: [],
    headers: [
      { text: "Data e Hora", value: "dataProgramadaEnvio" },
      { text: "Mensagem", value: "corpoNotificacao" },
      { text: "Status", value: "statusEnvio" },
      { text: "Ações", value: "acao", sortable: false },
    ],
    headersNotificacoesAutomaticas: [
      { text: "Tipo", value: "tipo" },
      { text: "Meio de envio", value: "meioEnvio" },
      { text: "Assunto", value: "assunto" },
      { text: "Corpo da notificação", value: "corpoNotificacao" },
      { text: "Ações", value: "acao", sortable: false },
    ],
    search: "",
    tab: null,
    notificacoesAutomaticas: [],
    tipos: [
      { text: "Parcela em atraso", value: "1" },
      { text: "Parcela próximo ao vencimento", value: "2" },
      { text: "Data próxima assembléia", value: "3" },
      { text: "Aniversário", value: "4" },
      { text: "Data personalizada", value: "5" },
    ],
    meiosEnvio: [
      { text: "Cota a Cota", value: "1" },
      { text: "Consorciado", value: "2" },
    ],
  }),
  mounted() {
    this.carregarNotificacoes();
    this.carregarNotificacoesAutomaticas();
  },
  methods: {
    menuRoute(name) {
      try {
        const route = this.$router.resolve({ name }).route;
        const selected = this.$route.path.startsWith(route.path);
        return route.matched.length
          ? { text: route.meta.title, to: route.path, selected }
          : { text: "// fixme" };
      } catch (e) {
        return false;
      }
    },
    acessar(item) {
      if (item.click) {
        item.click();
      } else {
        try {
          if (this.$route.path !== item.to) {
            this.$router.push(item.to);
          }
        } catch (e) {
          return false;
        }
      }
    },
    carregarNotificacoes() {
      this.loading = true;

      return this.$http
        .get("/notificacao")
        .then((res) => {
          this.items = [];
          this.$nextTick(() => {
            this.items = res.data;
          });
        })
        .catch(() => {
          // cancel
        })
        .finally(() => (this.loading = false));
    },
    carregarNotificacoesAutomaticas() {
      this.loading = true;

      return this.$http
        .get("/notificacaoAutomatica")
        .then((res) => {
          this.notificacoesAutomaticas = [];
          this.$nextTick(() => {
            this.notificacoesAutomaticas = res.data.filter((x) => {
              return x.status != 0;
            });
          });
        })
        .catch(() => {
          // cancel
        })
        .finally(() => (this.loading = false));
    },
    editarNotificacao(item) {
      window.localStorage.setItem("editarNotificacao", item.id);

      this.acessar(this.menuRoute("notificacaoAvulsa"));
    },

    listarCotas(item) {
      window.localStorage.setItem("notificacaoListarCotas", item.id);

      this.acessar(this.menuRoute("notificacaoCotas"));
    },
    excluirNotificacao(item) {
      alert({
        text: `Você tem certeza que deseja excluir a notificação selecionada? Essa operação não poderá ser desfeita.`,
        showCloseButton: true,
        img_topo: false,
        buttons: {
          Sim: () => {
            this.$http
              .delete("/notificacao/" + item.id)
              .then(() => {
                alert("Notificação removida com sucesso!");
                this.carregarNotificacoes();
              })
              .catch(() => {
                error(null, "Falha ao remover notificação, tente novamente.”");
              });
          },
          Cancelar: () => true,
        },
      });
    },
    excluirNotificacaoAutomatica(item) {
      alert({
        text: `Você tem certeza que deseja excluir a notificação automática selecionada? Essa operação não poderá ser desfeita.`,
        showCloseButton: true,
        img_topo: false,
        buttons: {
          Sim: () => {
            this.$http
              .delete("/notificacaoAutomatica/" + item.id)
              .then(() => {
                alert("Notificação automática removida com sucesso!");
                this.carregarNotificacoesAutomaticas();
              })
              .catch(() => {
                error(
                  null,
                  "Falha ao remover notificação automática, tente novamente.”"
                );
              });
          },
          Cancelar: () => true,
        },
      });
    },
  },
};
</script>
